import { Dialog, DialogActions, DialogTitle, Typography, Button, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {
  queryAdderPopupActionButtonSx,
  queryAdderPopupActionsSx,
  queryAdderPopupDescriptionSx,
  queryAdderPopupHeaderSx,
  queryAdderPopupPaperSx,
  queryAdderPopupTitleSx,
} from '../QueryAdder/queryAdderPopupStyles';

interface VerificationModalProps {
  openVerificationModal: boolean;
  setOpenVerificationModal: React.Dispatch<React.SetStateAction<boolean>>;
  modalTitle: string;
  modalDescription: string;
  handleYesClick: React.MouseEventHandler<HTMLButtonElement>;
  accentColor?: string;
}

const VerificationModal = (props: VerificationModalProps) => {
  const { openVerificationModal, setOpenVerificationModal, modalTitle, modalDescription, handleYesClick, accentColor } =
    props;

  const handleClose = () => {
    setOpenVerificationModal(false);
  };

  return (
    <Dialog
      open={openVerificationModal}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          ...queryAdderPopupPaperSx,
        },
      }}
    >
      <DialogTitle sx={queryAdderPopupHeaderSx}>
        <Typography sx={queryAdderPopupTitleSx}>{modalTitle}</Typography>
        <Typography sx={{ ...queryAdderPopupDescriptionSx, mt: 1 }}>{modalDescription}</Typography>
      </DialogTitle>
      <DialogActions sx={{ ...queryAdderPopupActionsSx, justifyContent: 'flex-end' }}>
        <Stack direction="row" spacing={1.5}>
          <Button
            onClick={() => setOpenVerificationModal(false)}
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={{
              ...queryAdderPopupActionButtonSx,
              ...(accentColor
                ? {
                    borderColor: accentColor,
                    color: accentColor,
                    '&:hover': {
                      borderColor: accentColor,
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }
                : {}),
            }}
            data-cy="Verification-no-button"
          >
            No
          </Button>
          <Button
            onClick={handleYesClick}
            variant="contained"
            startIcon={<CheckIcon />}
            sx={{
              ...queryAdderPopupActionButtonSx,
              ...(accentColor
                ? {
                    backgroundColor: accentColor,
                    '&:hover': {
                      backgroundColor: accentColor,
                    },
                  }
                : {}),
            }}
            aria-label="Verification-yes-button"
            data-cy="Verification-yes-button"
          >
            Yes
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationModal;
